module.exports = __webpack_public_path__ + "media/character-baby-content.99fc9de2.mp3";